export default "__VITE_ASSET__JkaMiWWK__"